module.exports = __webpack_public_path__ + "static/media/andoid-512.4efc7bf3.png";